angular.module('unica_invitation_list.invitation_list_services')

.factory('InvitationListComunicateService', function ($http, $window, getBaseApiURL) {

	var invitationListComunicateService = {};

	// DEM
	invitationListComunicateService.updateDem = function (invitationListData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem/' + invitationListData.id,
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListComunicateService.deleteDem = function(id)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/invitation-list/remove-dem/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	invitationListComunicateService.deleteDemLogo = function(id)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/invitation-list/remove-dem-logo/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	invitationListComunicateService.previewDem = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};



	// DEM CONFIRMATION

	invitationListComunicateService.updateDemConfirmation = function (invitationListData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem-confirmation/' + invitationListData.id,
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListComunicateService.deleteDemConfirmation = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/invitation-list/remove-dem-confirmation/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	invitationListComunicateService.deleteDemConfirmationLogo = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/invitation-list/remove-dem-confirmation-logo/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	invitationListComunicateService.deleteDemConfirmationProgram = function (invitationListId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-list/remove-dem-confirmation-program/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListComunicateService.deleteDemConfirmationPrivacy = function (invitationListId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-list/remove-dem-confirmation-privacy/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListComunicateService.previewDemConfirmation = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem-confirmation/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	// BADGE

	invitationListComunicateService.updateBadge = function (invitationListData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-badge/' + invitationListData.id,
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListComunicateService.deleteBadge = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/invitation-list/remove-badge/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	invitationListComunicateService.deleteBadgeLogo = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/invitation-list/remove-badge-logo/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	invitationListComunicateService.previewBadge = function (id) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-badge/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};


	// ICS

	invitationListComunicateService.updateIcs = function (invitationListData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-ics/' + invitationListData.id,
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};


	// APPROVATION LIST DEM

	invitationListComunicateService.updateDemALZM = function (invitationListData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem-al-zm/' + invitationListData.id,
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListComunicateService.previewDemALZM = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem-al-zm/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	invitationListComunicateService.updateDemALAM = function (invitationListData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem-al-am/' + invitationListData.id,
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListComunicateService.previewDemALAM = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem-al-am/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	invitationListComunicateService.updateDemALZMConfirmation = function (invitationListData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem-al-zm-confirmation/' + invitationListData.id,
			data: invitationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};

	invitationListComunicateService.previewDemALZMConfirmation = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem-al-zm-confirmation/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	invitationListComunicateService.updateDemDeclined = function (eventData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem-declined/' + eventData.id,
			data: eventData
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});
	};

	invitationListComunicateService.previewDemDeclined = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem-declined/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};



	return invitationListComunicateService;
});